export default __webpack_public_path__ + "static/media/bot1.810f73b3.jpeg";